import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import { isNil } from "ramda";

import Autocomplete from "@mui/material/Autocomplete";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import { IUserNetwork } from "types/api/addonsApiInterface";

const NfsBox = ({
 networks,
 selectedNetwork,
 selectNetwork
}: {
 networks: Array<IUserNetwork>;
 selectedNetwork: number;
 selectNetwork: (netid: number) => void;
}): ReactElement => {
 return (
  <Stack spacing={2}>
   <Stack>
    <Typography variant="subtitle2">
     <FormattedMessage id="server.add.nfsServerDescription" />
    </Typography>
    <Typography variant="subtitle2">
     <FormattedMessage id="server.add.nfsServerNetwork" />
    </Typography>
   </Stack>
   <Stack>
    <Autocomplete
     fullWidth={true}
     autoHighlight
     sx={{ my: 2 }}
     onChange={(e, value) => {
      if (isNil(value)) {
       selectNetwork(0);
      } else {
       selectNetwork(value.id);
      }
     }}
     options={networks.map((element) => {
      return {
       id: element.id,
       label: element.name
      };
     })}
     value={networks
      .map((element) => {
       return {
        id: element.id,
        label: element.name
       };
      })
      .find((element) => element.id === selectedNetwork)}
     renderInput={(params) => (
      <TextField
       {...params}
       onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
        e.stopPropagation();
       }}
       label={<FormattedMessage id="app.networks" />}
       InputLabelProps={{ shrink: true }}
      />
     )}
    />
   </Stack>
   <Stack>
    <Typography variant="subtitle2">
     <FormattedMessage
      id="server.add.nfsServerNetworkNotFound"
      values={{
       link: (
        <a href="/addons/network/add">
         <FormattedMessage id="addons.network.addNetwork" />
        </a>
       )
      }}
     />
    </Typography>
   </Stack>
  </Stack>
 );
};

export default NfsBox;
